<template>
  <div id="page-bottom-sheets">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg6>
          <v-widget title="Inset">
            <div slot="widget-content">
              <v-bottom-sheet inset>
                <v-btn slot="activator" color="red" dark>Show player</v-btn>
                <v-card tile>
                  <v-progress-linear height="3" :value="50" class="my-0"></v-progress-linear>
                  <v-list>
                    <v-list-item>
                      <v-list-item-action>
                        <v-list-item-title>The Walker</v-list-item-title>
                        <v-list-item-sub-title>Fitz & The Trantrums</v-list-item-sub-title>
                      </v-list-item-action>
                      <v-spacer></v-spacer>
                      <v-list-item-action>
                        <v-btn icon>
                          <v-icon>fast_rewind</v-icon>
                        </v-btn>
                      </v-list-item-action>
                      <v-list-item-action :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }">
                        <v-btn icon>
                          <v-icon>pause</v-icon>
                        </v-btn>
                      </v-list-item-action>
                      <v-list-item-action :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
                        <v-btn icon>
                          <v-icon>fast_forward</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-bottom-sheet>
            </div>
          </v-widget>
        </v-flex>
        <v-flex lg6>
          <v-widget title="Inset">
            <div slot="widget-content">
              <div class="text-xs-center">
                <v-bottom-sheet v-model="sheet">
                  <v-btn slot="activator" color="purple" dark>Click me</v-btn>
                  <v-list>
                    <v-subheader>Open in</v-subheader>
                    <v-list-item
                      v-for="tile in tiles"
                      :key="tile.title"
                      @click="sheet = false"
                    >
                      <v-list-item-avatar>
                        <v-avatar size="32px" tile>
                          <img :src="`/static/icon/${tile.img}`" :alt="tile.title">
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-title>{{ tile.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-bottom-sheet>
              </div>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
export default {
  components: {
    VWidget
  },
  data () {
    return {
      sheet: false,
      tiles: [
        { img: 'keep.png', title: 'Keep' },
        { img: 'inbox.png', title: 'Inbox' },
        { img: 'hangouts.png', title: 'Hangouts' },
        { img: 'google.png', title: 'Google+' }
      ]      
    };
  },
  computed: {
  },  
  methods: {
  }
};
</script>
